<template>
    <div class="vtn-voting"> 
        <div class="vtn-header">{{titleField.MyEvalProgressField}}</div>
        <div v-if="userPublicRatingTopicExpert.TexVote == 1 || !(userPublicRatingGroupInfo.RtgWithMainQuestion == true)" class="progressBar">
            <DxProgressBar id="progress-bar-status"
                           :min="0"
                           :max="maxValue"
                           :status-format="statusFormat"
                           :value="progressValue"
                           width="100%">

            </DxProgressBar>

        </div>
        <div class="status-progress" v-if="userPublicRatingTopicExpert.TexVote == 1 || !(userPublicRatingGroupInfo.RtgWithMainQuestion == true)">
            {{progressValue}} / {{maxValue}}
        </div>
        <div class="bewertung-status" v-if="userPublicRatingTopicExpert.TexVote == 1 || !(userPublicRatingGroupInfo.RtgWithMainQuestion == true)">
            <div v-if="progressValue/maxValue<=0.45">

            </div>
            <div v-if="0.45<=progressValue/maxValue&& progressValue/maxValue<=0.55">
                {{progressValueHint.HalfProgress}}
            </div>
            <div v-if="0.55<=progressValue/maxValue && progressValue/maxValue!=1">

                {{progressValueHint.AlmostProgress}}
            </div>
            <div v-if="progressValue/maxValue==1">

                {{progressValueHint.CompletedProgress}}
            </div>
        </div>
        <div class="vtn-rtg">
            <div class="vtn-rtg-caption" v-html="userPublicRatingGroupInfo.RtgCaption"></div>
            <div class="vtn-rtg-description" v-html="userPublicRatingGroupInfo.RtgDescription"></div>
        </div>

        <div class="vtn-rtg-question" v-if="userPublicRatingGroupInfo.RtgWithMainQuestion">

            <div class="vtn-rtg-question-title" v-html="userPublicRatingGroupInfo.RtgMainQuestionTitle"></div>
            <div class="vtn-rtg-question-text" v-html="userPublicRatingGroupInfo.RtgMainQuestionText"></div>
            <div class="vtn-rtg-score">
                <DxSelectBox displayExpr="text" :dataSource="scoreList" valueExpr="id" v-model="userPublicRatingTopicExpert.TexVote" @valueChanged="onTexChanged">
                </DxSelectBox>
            </div>
        </div>

        <div v-if="userPublicRatingTopicExpert.TexVote == 1 || !(userPublicRatingGroupInfo.RtgWithMainQuestion == true)" style="display:contents;">

            <div class="vtn-voting-list" v-for="rating in userPublicRatingList" :key="rating.RtyId">

                <div class="vtn-voting-item">
                    <div class="vtn-voting-caption">
                        <div class="vtn-voting-caption-text">{{ rating.RtyCaption }}</div>
                        <div class="vtn-voting-caption-score" v-if="rating.Vote.RatId != null && rating.Vote.RatNoVote == false" @click="onRatingChangedIcon(rating)"><i class="fa-light fa-circle-check"></i></div>
                        <div class="vtn-voting-caption-noscore" v-if="rating.Vote.RatId == null " @click="onRatingChangedIcon(rating)"><i class="fa-light fa-empty-set"></i></div>
                        <div class="vtn-voting-caption-noscore" v-if=" rating.Vote.RatNoVote" @click="onRatingChangedIcon(rating)"><i class="fa-light fa-circle-question"></i></div>
                    </div>
                    <div class="vtn-voting-description">{{ rating.RtyName }}</div>


                    <div class="vtn-score">
                        <div class="vtn-score-min">{{rating.RtyMinimum}}</div>
                        <div class="vtn-score-slider">
                            <DxSlider :min="rating.RtyMinimum"
                                      :max="rating.RtyMaximum"
                                      :step="rating.RtyStep"
                                      v-model:value="rating.Vote.RatScore" @valueChanged="onRatingChanged(rating)" />
                            <div class="vtn-voting-slider-score" v-if="rating.Vote.RatId != null && rating.Vote.RatNoVote == false">{{ rating.Vote.RatScore }}</div>
                            <div class="vtn-voting-slider-score-NA" v-if="rating.Vote.RatId != null && rating.Vote.RatNoVote == true">N/A</div>
                            <div class="vtn-voting-slider-score" v-if="rating.Vote.RatId == null ">--Bitte bewegen Sie Slider zur Bewertung-- </div>
                        </div>
                        <div class="vtn-score-max">{{ rating.RtyMaximum}}</div>
                    </div>
                    <div class="vtn-voting-comment" v-if="rating.RtyWithComment">
                        <DxTextArea v-model:value="rating.Vote.RatComment" @valueChanged="onRatingChanged(rating)" placeholder="Comment" :autoResizeEnabled="true"></DxTextArea>
                    </div>
                </div>
            </div>
        </div>
        <div style="display:contents;" v-if="userPublicRatingGroupInfo.RtgWithComment">
            <div class="vtn-voting-overallcomment">
                <div class="vtn-voting-overallcomment-title">
                    Overall Comment
                </div>
                <div class="vtn-voting-overallcomment-score">
                    <DxTextArea v-model:value="userPublicRatingTopicExpert.TexVoteJustification" @valueChanged="onTexChanged" placeholder="Overall Comment" :autoResizeEnabled="true"></DxTextArea>
                </div>
            </div>
        </div>
    </div>
    <DxToast v-model:visible="isToastVisible"
             v-model:message="ToastMessage"
             :displayTime="4000"
             v-model:type="ToastType"
             maxWidth="80%">


    </DxToast>
</template>

<script>
    import { DxSlider } from 'devextreme-vue/slider';
    import { DxToast } from 'devextreme-vue/toast';
    import { DxSelectBox } from 'devextreme-vue/select-box';
    import { DxTextArea } from 'devextreme-vue/text-area';
    import { DxProgressBar } from 'devextreme-vue/progress-bar';


    export default {
        name: 'Voting',
        components: {
            DxSlider,
            DxTextArea,
            DxSelectBox,
            DxToast,
            DxProgressBar
        },
        props: {
            rtgId: {
                type: [Number],
                required: true,
                default: 0
            },
            topicId: {
                type: [Number],
                required: true,
                default: 0,
                immediate: true,
            },
        },
        data() {
            return {
                texLoaded: false,
                ratLoaded: false,
                texChanged: false,
                ratChanged: false,
                scoreList: [{ id: 1, text: "Relevanz" }, { id: 2, text: "nicht relevant" }],
                isToastVisible: false,
                ToastMessage: 'Your changes have been saved',
                ToastType: 'success',
                currentTopicId: 0,
                voteIconClicked: 0,
                progressValueHint: {
                    HalfProgress: this.$LanguageProvider.GetResource("HalfProgress", "Hint", "Hälfte geschafft!"),
                    AlmostProgress: this.$LanguageProvider.GetResource("AlmostProgress", "Hint", "Fast geschafft!"),
                    CompletedProgress: this.$LanguageProvider.GetResource("CompletedProgress", "Hint", "Geschafft! Danke für die Bewertung"),
                   
                },
                titleField: {
                    MyEvalProgressField: this.$LanguageProvider.GetResource("MyEvalProgressField", "Title", "Meine Bewertung"),
                }

            }
        },
        beforeCreate: function () {
            this.texLoaded = false
            this.ratLoaded = false
            this.texChanged = false
            this.ratChanged = false
            console.log("beforeCreate")
        },
        computed: {

            userPublicRatingList() {
                return this.$store.state.ratingStore.userPublicRatingList
            },
            progressValue() {
                let stillUnRated = this.userPublicRatingList.filter((r) => r.Vote.RatId != null)
                return stillUnRated.length;
            },
            maxValue() {
                return this.userPublicRatingList.length;
            },
            userPublicRatingTopicInfo() {
                return this.$store.state.ratingStore.userPublicRatingTopicInfo
            },
            userPublicRatingTopicExpert() {
                return this.$store.state.ratingStore.userPublicRatingTopicExpert
            },
            userPublicRatingGroupInfo() {
                return this.$store.state.ratingStore.userPublicRatingGroupInfo
            },
        },
        mounted: function () { 
        },
        watch: {
            topicId: {
                handler() {
                    this.loadData(this.topicId)
                },
                deep: true,
                immediate: true
            },
        },
        methods: {

            statusFormat() {
                return ` `;
            },
            loadData(topicId) {
                let uri = window.location.search.substring(1);
                let params = new URLSearchParams(uri);
                let args = params.get("args"); 
                this.$store.dispatch("getPublicVoting", { args: args, topicId: topicId, rtgId: this.rtgId }).then(() => {
                    setTimeout(() => {
                        this.texLoaded = true
                        this.ratLoaded = true
                    }, 500)
                    console.log("mounted")
                })
            },
            onRatingChangedIcon: function (rating) {
                if (this.ratLoaded && !rating.isSending) {

                    if (this.voteIconClicked == 0)
                        this.voteIconClicked = 1

                    if (rating.Vote.RatScore == null) {
                        rating.Vote.RatScore = 0
                        rating.Vote.RatNoVote = false

                    }
                    rating.isSending = true
                    if (rating.Vote.RatId == null) {
                        rating.Vote.RatId = 0
                        rating.Vote.RatNoVote = false
                    }
                    else if (this.voteIconClicked == 1) {
                        /*   this.voteIconClicked = 0*/
                        rating.Vote.RatScore = 0
                        rating.Vote.RatNoVote = !rating.Vote.RatNoVote

                    }


                    console.log("updateVote", rating)
                    setTimeout(() => this.updateVote(rating), 1500)
                }
            },
            onRatingChanged: function (rating) {
                if (this.ratLoaded && !rating.isSending) {
                    if (rating.Vote.RatScore == null) {
                        rating.Vote.RatScore = 0
                    }
                    rating.isSending = true
                    if (rating.Vote.RatId == null) {
                        rating.Vote.RatId = 0
                    }
                    rating.Vote.RatNoVote = false
                    console.log("updateVote", rating)
                    setTimeout(() => this.updateVote(rating), 1500)
                }
            },
            updateVote(rating) {
                this.$store.dispatch("updateMyVoting", {
                    rtgId: this.rtgId,
                    topicId: this.topicId,
                    rtyId: rating.RtyId,
                    ratScore: rating.Vote.RatScore,
                    ratComment: rating.Vote.RatComment,
                    ratNoVote: rating.Vote.RatNoVote
                }).then(() => {
                    this.isToastVisible = true
                    this.loaded = true
                })
                rating.isSending = false
            },
            onTexChanged: function () {
                const tex = this.userPublicRatingTopicExpert
                if (this.texLoaded && !tex.isSending) {
                    console.log("updateVote", tex)
                    this.texChanged = true
                    setTimeout(() => this.updateTex(tex), 500)
                }
            },
            updateTex(tex) {
                this.$store.dispatch("updateMyTex", {
                    TexId: tex.TexId,
                    TexVote: tex.TexVote,
                    TexVoteJustification: tex.TexVoteJustification,
                }).then(() => {
                    this.isToastVisible = true
                    this.loaded = true
                })
                tex.isSending = false
            },
            goBack() {
                setTimeout(() => {
                    this.$router.push({ name: 'VotingOverview', query: { rtgId: this.rtgId } })
                }, 50)
            }
        }
    }

</script>

<style scoped>
    .singleButton {
        margin-top: 30px;
    }

    .fa-light {
        font-size: 20px;
    }

        .fa-light:hover {
            cursor: pointer;
        }

    .fa-circle-question {
        color: var(--danger-color)
    }

    .fa-circle-check {
        color: var(--m02-color-1);
    }

    .singleButton:hover {
        background-color: var(--round-end);
        color: black
    }

    .vtn-topic {
        display: flex;
        gap: 10px;
        margin-top: 20px;
        font-weight: bold;
        font-size: 24px;
    }


    .vtn-rtg-question-title {
        font-weight: bold;
    }

    .vtn-rtg-description {
        font-size: 12px;
        color: var(--main-color-1);
        padding-bottom:10px;
    }

    .vtn-voting-caption {
        display: flex;
        justify-content: space-between;
        font-weight: bold;
        margin-top: 20px;
        margin-bottom: 4px;
    }

    .vtn-voting-caption-score {
        color: var(--main-color-1);
    }

    .vtn-voting-slider-score {
        text-align: center;
        color: var(--m02-color-1);
        padding-top: 5px;
        padding-bottom: 5px;
        font-size: 10px;
    }

    .vtn-voting-slider-score-NA {
        text-align: center;
        color: var(--danger-color);
        padding-top: 5px;
        padding-bottom: 5px;
        font-size: 10px;
    }

    .vtn-voting-caption-noscore {
        color: var(--danger-color);
    }

    .vtn-score {
        display: grid;
        grid-template-columns: 10px auto 10px;
        margin-bottom: 6px;
    }

    .vtn-score-min,
    .vtn-score-max {
        align-self: center;
        font-size: 12px;
        color: var(--gray-color-1);
        padding-top: 2px;
    }

    .vtn-voting-list {
        border-bottom: inset;
        border-bottom-width: 1px;
        padding-bottom: 17px;
        break-inside: avoid;
    }

    .vtn-voting-overallcomment {
        margin-top: 20px;
    }

    .vtn-voting-overallcomment-title {
        font-weight: bold;
        margin-bottom: 5px;
    }

    .dx-show-invalid-badge.dx-textarea.dx-textbox.dx-texteditor.dx-editor-outlined.dx-texteditor-empty.dx-widget.dx-visibility-change-handler {
        font-family: var(--font-family);
    }

    .vtn-rtg-question {
        break-inside: avoid;
    }

    .vtn-header {
        background-color: var(--danger-color);
        color: white;
        padding: 3px 3px 3px 6px;
        font-weight: bold;
    }

    .vtn-rtg-caption {
        margin-top: 5px;
        font-weight: bold;
        margin-bottom: 5px;
    }

    #progress-bar-status {
        display: inline-block;
    }
 
  
    .progressBar {
        padding-top: 20px;
    }
    .bewertung-status {
        font-weight: 600;
        padding-bottom: 10px;
        border-bottom: solid 1px;
        color: var(--m01-color-1);
        margin-top: -10px;
    }
    .vtn-rtg {
        color: var(--danger-color)
    }
    .status-progress {
        transform: translate(20px,-19px);
        color: white;
    }
</style>